import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useContext } from "react";
import Contexto from "../context/Contexto";
import Carita from "../assets/CCstatics/avatar11.png";

import "../assets/css/Home.css";
import "../assets/css/Login.css";

function Gracias() {
  const {} = useContext(Contexto);

  return (
    <>
      <section className="home ">
        <div className="soporteLogin">
          <div className="login">
            <div className="login__wrapper centradoCompra">
              <br />
              <br />
              <img src={Carita} alt="" />
              <p className="titFelicitaciones">¡Gracias por sumarte!</p> <br />
              <br />
              <p className="datita">
                Dentro de MIS CURSOS podés encontrar <br /> todo el contenido de{" "}
                <br /> Color Club
              </p>
              <br />
              <Link to="miscursos" className="formuBT">
                MIS CURSOS
              </Link>
              <br />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Gracias;
